import { useEffect, useState } from "react";
import axios from "axios";

const STORAGE_KEY = "version-update-needed";

export function useVersionCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  async function checkVersion() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/version?t=${Date.now()}`,
        { cache: "no-store" }
      );

      const serverVersion = response.data.version;
      const clientVersion = process.env.REACT_APP_VERSION;

      if (!serverVersion || !clientVersion) return;

      if (serverVersion !== clientVersion) {
        localStorage.setItem(STORAGE_KEY, serverVersion);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }

      const storedVersion = localStorage.getItem(STORAGE_KEY);

      setUpdateAvailable(
        Boolean(storedVersion && storedVersion !== clientVersion)
      );
    } catch (err) {
      console.warn("Version check failed:", err.message);
    }
  }

  useEffect(() => {
    checkVersion();
    const interval = setInterval(checkVersion, 30 * 60_000);
    return () => clearInterval(interval);
  }, []);

  // If one tab refreshes, others can auto-hide the banner using storage events.
  useEffect(() => {
    const onStorage = () => checkVersion();
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const refreshApp = () => {
    localStorage.removeItem(STORAGE_KEY);
    window.location.reload(true);
  };

  return { updateAvailable, refreshApp };
}
